// «Visuales · <cliente>»: tableros de clientes hechos en la maqueta Knobloch-Draft (Iván, Mariana). Los tableros
// viven en ./maqueta (los genera scripts/maqueta_tableros_sync.py: NO se editan) y sus datos en
// backend/routes/nike_tableros.py, backend/routes/tiendas_bara.py y backend/routes/bodesa_elasticidad.py. Cada cliente
// es un módulo con su flag en module_features (default apagado; el backend también lo valida). Esta lista la usan las
// dos plataformas: la de siempre (TablerosCliente.jsx, pestañas en la página) y la nueva
// (src/nueva/modulos/visualesClientes, un tablero por opción en el acordeón del menú).
import { lazy } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Activity, BadgePercent, Dumbbell, Footprints, History, LayoutGrid, ShoppingBasket, Table2 } from 'lucide-react';

const desde = (cargar, nombre) => lazy(() => cargar().then((m) => ({ default: m[nombre] })));

export const CLIENTES = {
  visualesNike: {
    feature: 'visualesNike',
    titulo: 'Reports', // nombre en el menú que pidió Iván (2026-10-29); el módulo sigue siendo visualesNike
    cliente: 'Nike',
    ruta: '/visuales-nike',
    tableros: [
      { id: 'sport', label: 'Price Positioning by Sport', icon: Dumbbell, Componente: lazy(() => import('./maqueta/sport/SportPositioning')) },
      { id: 'pricewall', label: 'Price Wall · Running', icon: Footprints, Componente: lazy(() => import('./maqueta/pricewall/PriceWall')) },
      { id: 'markdown', label: 'Markdown', icon: BadgePercent, Componente: lazy(() => import('./maqueta/markdown/Markdown')) },
    ],
  },
  visualesTiendasBara: {
    feature: 'visualesTiendasBara',
    titulo: 'Visuales · Tiendas Bara',
    cliente: 'Tiendas Bara',
    ruta: '/visuales-tiendas-bara',
    tableros: [
      { id: 'onepager', label: 'One Pager', icon: ShoppingBasket, Componente: desde(() => import('./maqueta/bara/OnePagerBara'), 'OnePagerBara') },
      { id: 'categorias', label: 'Análisis categorías', icon: LayoutGrid, Componente: desde(() => import('./maqueta/bara/OnePagerBara'), 'AnalisisCategoriasBara') },
      { id: 'portafolio', label: 'Portafolio', icon: Table2, Componente: lazy(() => import('./maqueta/bara/PortafolioBara')) },
      { id: 'historico', label: 'Histórico', icon: History, Componente: lazy(() => import('./maqueta/bara/HistoricoBara')) },
    ],
  },
  visualesBodesa: {
    feature: 'visualesBodesa',
    titulo: 'Visuales · Bodesa',
    cliente: 'Bodesa',
    ruta: '/visuales-bodesa',
    tableros: [
      { id: 'elasticidad', label: 'Elasticidad de precios', icon: Activity, Componente: lazy(() => import('./maqueta/elasticidad/ElasticidadBodesa')) },
    ],
  },
};

export const rutaTablero = (cliente, id) => `${cliente.ruta}?tablero=${id}`;

/** Tablero activo según ?tablero= (el primero si falta o no existe) y cómo cambiarlo sin apilar historial. */
export function useTableroActivo(cliente) {
  const [params, setParams] = useSearchParams();
  const tablero = cliente.tableros.find((t) => t.id === params.get('tablero')) ?? cliente.tableros[0];
  const cambiar = (id) => setParams({ tablero: id }, { replace: true });
  return [tablero, cambiar];
}
